module.exports = __webpack_public_path__ + "img/iso-cert.24b7656f.svg";